import { render, staticRenderFns } from "./submitStep1.vue?vue&type=template&id=69be0f97&scoped=true"
import script from "./submitStep1.vue?vue&type=script&lang=js"
export * from "./submitStep1.vue?vue&type=script&lang=js"
import style0 from "./submitStep1.vue?vue&type=style&index=0&id=69be0f97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69be0f97",
  null
  
)

export default component.exports